import React, { FC, useState } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import useResponsive from "../../hooks/useResponsive";
import BadgeImage from "../ui-elements/badge-image";
import TypographyContent from "../ui-elements/typography-content";
import ImageGrid from "../image-grid";
import { PATH_DASHBOARD } from "../../routes/path";
import { formatDateAndTimeFromString } from "../../utils/date-setup";
import TruncatedLimitContent from "../ui-elements/typography-limit-content";

export const PostContent = ({ post }: { post: any }) => {
  const isMedium = useResponsive("down", "md", "xl");
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        border: "1px solid rgba(231, 235, 239, 1)",
        my: 2,
        borderRadius: "8px",
        padding: isMedium ? 1 : 2,
        minHeight: 150,
        width: "94%",
        marginHorizontal: "auto",
      }}
    >
      <Box
        sx={{
          marginVertical: 2,
        }}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={2}
            sx={{
              marginBottom: 2,
            }}
          >
            {/* image */}
            <img
              src={post?.author_photo_url}
              alt="avat"
              style={{ width: 32, height: 32, borderRadius: "20px" }}
            />

            <Stack>
              <Stack direction={"row"}>
                <Typography sx={{ fontSize: 13 }} color="black">
                  {post?.author}
                </Typography>
                {post?.badge > 0 && <BadgeImage badge={post?.badge} />}
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: 12 }} color="">
                  {formatDateAndTimeFromString(post?.created_at)}
                </Typography>
              </Stack>

              <Typography
                sx={{ fontSize: 12, fontStyle: "italic" }}
                color="primary"
              >
                {post?.post_type}
              </Typography>
            </Stack>
            {/*dot image */}
          </Stack>
        </Stack>
        <Box sx={{ ml: isMedium ? 0 : 3 }}>
          <Stack
            sx={{ cursor: "pointer" }}
            onClick={() =>
              navigate(PATH_DASHBOARD.post, {
                state: { postId: post?.id },
              })
            }
          >
            <Typography
              color="black"
              sx={{
                fontSize: 16,
                marginBottom: 2,
              }}
            >
              {post?.title}
            </Typography>
            <Box onClick={() => navigate(post?.link)}>
              <ImageGrid
                images={post?.media} // Pass images as an array
              />
            </Box>
            <Stack sx={{ mt: 2 }}>
              <TruncatedLimitContent content={post?.context} />
            </Stack>
          </Stack>

          <Divider sx={{ mt: 3 }} />
        </Box>
      </Box>
    </Box>
  );
};

// export const AccountContent = ({ account }: { account: any }) => {
//   const isMedium = useResponsive("down", "md", "xl");
//   const navigate = useNavigate();
//   return (
//     <Box
//       sx={{
//         border: "1px solid rgba(231, 235, 239, 1)",
//         my: 2,
//         borderRadius: "8px",
//         padding: isMedium ? 1 : 2,
//         minHeight: 150,
//         width: "94%",
//         marginHorizontal: "auto",
//       }}
//     >
//       <Box
//         sx={{
//           marginVertical: 2,
//         }}
//       >
//         <Stack
//           direction="row"
//           alignItems={"center"}
//           justifyContent={"space-between"}
//         >
//           <Stack
//             direction={"row"}
//             alignItems={"center"}
//             spacing={2}
//             sx={{
//               marginBottom: 2,
//             }}
//           >
//             {/* image */}
//             <img
//               src={"/assets/images/home/irep-image.png"}
//               alt="avat"
//               style={{ width: 32, height: 32 }}
//             />

//             <Stack>
//               <Stack direction={"row"}>
//                 <Typography sx={{ fontSize: 13 }} color="black">
//                   {account?.author}
//                 </Typography>
//                 {account?.badge > 0 && <BadgeImage badge={account?.badge} />}
//               </Stack>
//               <Stack>
//                 <Typography sx={{ fontSize: 12 }} color="">
//                   {formatDateAndTimeFromString(account?.created_at)}
//                 </Typography>
//               </Stack>

//               <Typography
//                 sx={{ fontSize: 12, fontStyle: "italic" }}
//                 color="primary"
//               >
//                 {account?.post_type}
//               </Typography>
//             </Stack>
//             {/*dot image */}
//           </Stack>
//         </Stack>
//         <Box sx={{ ml: isMedium ? 0 : 3 }}>
//           <Stack
//             sx={{ cursor: "pointer" }}
//             onClick={() =>
//               navigate(PATH_DASHBOARD.post, {
//                 state: { postId: post?.id },
//               })
//             }
//           >
//             <Typography
//               color="black"
//               sx={{
//                 fontSize: 16,
//                 marginBottom: 2,
//               }}
//             >
//               {post?.title}
//             </Typography>
//           </Stack>

//           <Divider sx={{ mt: 3 }} />
//         </Box>
//       </Box>
//     </Box>
//   );
// };
